import { render, staticRenderFns } from "./PopupRank.vue?vue&type=template&id=5195115e&"
import script from "./PopupRank.vue?vue&type=script&lang=js&"
export * from "./PopupRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports